import React from 'react';
import SectionWrapper from '../SectionWrapper/SectionWrapper';
// import ContentContainer from '../ContentContainer/ContentContainer';
import Box from '../Box/Box';
import getDisplayName from '../../utils/getDisplayName';
import { css } from 'styled-components';

interface WithSectionProps {
    styling?: any;
}

const WithSection = <
    P extends {
        id?: string;
    }
>(
    Component: React.ComponentType<P>,
    showOnlyInDesktop?: boolean
): React.FC<P & WithSectionProps> => {
    const WrappedComponent = ({ styling, id, ...props }: WithSectionProps) => {
        // const hasBadge = badges?.[0]?.badge;
        return (
            <Box
                display={
                    showOnlyInDesktop && {
                        _: 'none !important',
                        lg: 'block !important',
                    }
                }
                as="section"
                id={id}
                // position={hasBadge && 'relative'}
                css={css`
                    scroll-margin-top: var(--header-height);
                `}
            >
                <SectionWrapper {...styling}>
                    <Component id={id} {...props} styling={styling} />
                </SectionWrapper>

                {/* {badges?.[0]?.badge && (
                    <Box
                        position="absolute"
                        top="0"
                        bottom="0"
                        left="0"
                        right="0"
                        pointerEvents="none"
                    >
                        <Box
                            as={ContentContainer}
                            position="relative"
                            height="100%"
                            width="100%"
                        >
                            <BadgeSlots badges={badges} />
                        </Box>
                    </Box>
                )} */}
            </Box>
        );
    };
    WrappedComponent.displayName = `WithSection(${getDisplayName(Component)})`;

    return Component === null ? null : WrappedComponent;
};

export default WithSection;
